var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suggestion-item",class:_vm.wrapperClasses},_vm._l((_vm.contentLines),function(contentLine,idx){return _c('p',{key:idx,domProps:{"innerHTML":_vm._s(contentLine)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }